import API from "@/utils/api/index";

// Fetch both active and pending promos
export async function fetchPromos() {
  try {
    const res = await API.get("/promos");
    return res.data;
  } catch (err) {
    console.error("[fetchPromos] Error:", err.response?.data || err.message);
    throw Object.assign(new Error(err.response?.data?.error || "Failed to fetch promos"), {
      status: err.response?.status || 500,
    });
  }
}

export async function fetchPromoById(promoId) {
  try {
    const res = await API.get(`/promos/${promoId}`);
    return res.data;
  } catch (err) {
    console.error("[fetchPromoById] Error:", err.response?.data || err.message);
    throw Object.assign(new Error(err.response?.data?.error || "Failed to fetch promo"), {
      status: err.response?.status || 500,
    });
  }
}
